import { useMemo } from 'react';

/**
 * Merge multiple react refs into a single ref callback.
 * This can be used to merge callback and object refs into a single ref.
 * Merged callback refs will be called while object refs will have their current property set.
 * @param refs The refs to merge
 * @returns A ref callback that will set the value on all refs
 */
export function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return newRef => {
    refs.forEach(ref => {
      if (ref != null) {
        if (typeof ref === 'function') {
          ref(newRef);
        } else {
          // React marks RefObject as readonly, but it's just to indicate React manages it
          // We can still write to its current value
          // eslint-disable-next-line no-param-reassign
          ref.current = newRef;
        }
      }
    });
  };
}

/**
 * Merges multiple refs into one ref that can be assigned to the component.
 * In turn all the refs passed in will be assigned when the ref returned is assigned.
 * @param refs Array of refs to assign
 */
export function useMergeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => mergeRefs(...refs), refs);
}
//# sourceMappingURL=useMergeRef.js.map